<template>
  <div class="content-page">
    <div class="mian-page">
      <div class="title-page"></div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <div class = "re-contentBox">
            <div class="textBox">
              <el-form :model="ruleForm" :label-position="labelPosition"  :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm search-items ">
                <el-form-item label="姓名" prop="loginName" class=" col1-2">
                  <el-input placeholder="请输入姓名" v-model.trim="ruleForm.loginName"  maxlength="20"></el-input>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="身份证号" prop="identificationCard" disabled class="col1-2">
                  <el-input placeholder="请输入身份证号码" v-model.trim="ruleForm.identificationCard"  maxlength="18"></el-input>
                </el-form-item>
                <div class="col1-2"></div>
                <el-form-item label="手机号码" prop="phone" class=" col1-2">
                  <el-input placeholder="请输入手机号码" v-model.trim="ruleForm.phone"  maxlength="20"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="btnLists">
            <div v-no-more-div class="primary-btn" @click="submitForm('ruleForm')"> 人脸识别 </div>
            <div v-no-more-div class="border-btn" style="margin-left: 20px" @click="$router.push('/codeSearch')" >返回上一页</div>
          </div>
        </div>
      </div>
    </div>
    <faceIdTip ref="faceIdTip" @nextTep="nextTep" />
    <registerDialog 
      :visible.sync="registerDialogVisible" 
      :initial-name="ruleForm.loginName"
      :initial-id-card="ruleForm.identificationCard"
      :initial-phone="ruleForm.phone"
      @register-success="handleRegisterSuccess"
      @close="handleRegisterDialogClose"
    />
    <!-- 注册异常弹窗 -->
    <el-dialog
      title="请确认"
      :visible.sync="showRegestStatusDialog"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="regest-status-dialog"
    >
      <div class="regest-status-content">
        <div class="regest-status-text" v-html="regestStatusTips"></div>
        <div class="regest-status-contact" v-if="regestStatusPhone || regestStatusTime">
          <div class="contact-item" v-if="regestStatusPhone">{{ regestStatusPhone }}</div>
          <div class="contact-item" v-if="regestStatusTime">{{ regestStatusTime }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ocrIdCardCheck, uuid } from '@/utils';
import Api from '@api/api';
import faceIdTip from '@/components/face/faceIdTip.vue';
import registerDialog from '@/components/registerDialog/registerDialog.vue';
import websocketManager from '@/utils/websocket';
const moduleCodeSwitch = () => {
  switch (localStorage.getItem('oprate')) {
    case 'apply':
      return '1';
      break;
    case 'search':
      return '2';
      break;
    case 'revokeApply':
      return '3';
      break;
  }
};
export default {
  name: 'Login',
  components: {
    faceIdTip,
    registerDialog
  },
  data () {
    var validatePhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (/\s+/g.test(this.ruleForm.loginName) || value === '') {
        callback(new Error('请输入正确的姓名'));
      } else {
        callback();
      }
    };

    var validateIdCard = (rule, value, callback) => {
      if (!/^[1-9]\d{5}(?:18|19|20|21|22)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(this.ruleForm.identificationCard) || value === '') {
        callback(new Error('请输入正确的证件号码'));
      } else {
        callback();
      }
    };
    return {
      caseOrderNo: uuid(), // 生成的案件流水号
      oprate: localStorage.getItem('oprate'),
      identificationApplicant: uuid(), // 姓名id 都uuid生成
      // 注册异常弹窗相关
      showRegestStatusDialog: false,
      regestStatusTips: '',
      regestStatusPhone: '',
      regestStatusTime: '',
      ruleForm: {
        fileListJpg: [],
        identificationCard: '',
        fileListJpg2: [],
        moduleCode: moduleCodeSwitch(),
        identificationType: '1001001',
        loginName: '',
        phone: ''
      },
      rules: {
        loginName: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        identificationCard: [
          { required: true, validator: validateIdCard, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ]
      },
      labelPosition: 'left',
      registerDialogVisible: false,
      // 注册异常弹窗相关
      showRegestStatusDialog: false,
      regestStatusTips: '',
      regestStatusPhone: '',
      regestStatusTime: ''
    };
  },
  created () {

  },
  mounted () {
    if (document.body.clientWidth <= 750) {
      this.labelPosition = 'top';
    } else {
      this.labelPosition = 'left';
    }
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth <= 750) {
          this.labelPosition = 'top';
        } else {
          this.labelPosition = 'left';
        }
      })();
    };
  },
  methods: {
    handleRemoveGh () {
      this.ruleForm.fileListJpg = [];
    },
    handleRemove () {
      this.ruleForm.fileListJpg2 = [];
    },
    // 上传文件之前的钩子
    beforeUpload (file) {
      const isLt100MB = file.size / 1024 / 1024 < 100;
      const a = file.name;
      const b = [
        '.jpg',
        '.gif',
        '.png',
        '.jpeg'
      ];
      const isType = b.includes(a.slice(a.lastIndexOf('.')).toLowerCase());
      if (!isLt100MB) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false;
        }
        this.$message({
          message: '上传文件大小不能超过 100MB!',
          type: 'warning',
          center: true
        });
        return false;
      }
      if (!isType) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false;
        }
        this.$message({
          message:
            '上传文件格式必须为1.jpg 2.jpeg 9.png',
          type: 'warning',
          center: true
        });
        return false;
      }
      if (!this.ruleForm.identificationCard) {
        this.$message({
          message:
            '请先输入身份证号！',
          type: 'warning',
          center: true
        });
        return false;
      }
    },

    // 限制文件上传个数
    handleExceed (files, fileList) {
      this.$message.warning('当前限制选择 1 个文件');
    },
    // 自定义上传
    handleUpload (param, kindType) {
      if (kindType == '4') {
        ocrIdCardCheck(param.file, this.ruleForm.loginName, this.ruleForm.identificationCard, (res) => {
          if (res.data.data) {
            this.uploadHandle(param, kindType);
          } else {
            this.$message.warning('请确认您的证件图片为本人原件且无破损');
            this.ruleForm.fileListJpg2 = [];
          }
        });
      } else {
        this.uploadHandle(param, kindType);
      }
    },
    uploadHandle (param, kindType) {
      const formData = new FormData();
      formData.append('caseOrderNo', this.caseOrderNo);
      formData.append('evidenceName', param.file.name);
      formData.append('evidence', param.file);
      formData.append('file', param.file);
      formData.append('kindType', kindType); // 证据材料类型（0证件照1具体行政行为材料2其他补充材料 3 身份证反面 4身份证正面）
      formData.append('identificationApplicant', this.identificationApplicant);
      Api.appletsUpload(formData)
        .then(({ data }) => {
          console.log(data, param);
          param.file.evidenceId = data.data.id;
          param.file.id = data.data.id;
          const fileListJpg = [];
          data.data.showPath = data.data.showPath.replace('landing.iflysec.com:80', 'landing.iflysec.com');
          // fileListJpg.push({...file, ...resData.data})
          fileListJpg.push({
            ...data.data,
            url: data.data.showPath,
            name: data.data.evidenceName,
            thumb: data.data.showPath,
            type: param.file.type
          });
          if (kindType == '3' || kindType == '0') {
            this.ruleForm.fileListJpg = fileListJpg;
          } else {
            this.ruleForm.fileListJpg2 = fileListJpg;
          }
        });
    },
    // 登出操作
    handleLogout () {
      // 断开 WebSocket 连接
      websocketManager.disconnect()
      
      // 清除登录相关数据
      localStorage.removeItem('applicantInfo')
      localStorage.removeItem('applicantCategory')
      localStorage.removeItem('sessionId')
      localStorage.removeItem('oprate')
      localStorage.removeItem('loginIdentificationCard')
      localStorage.removeItem('loginName')
      localStorage.removeItem('isLogin')
      localStorage.removeItem('isRegistered')
      
      // 清除 Vuex 中的登录状态
      this.$store.dispatch('clearLoginStatus')
      
      // 显示提示信息
      this.$message({
        type: 'warning',
        message: '登录已过期，请重新登录',
        duration: 4000
      })
      
      // 跳转到 codeSearch 页面
      if (this.$route.path !== '/codeSearch') {
        this.$router.push('/codeSearch')
      }
    },
    // 保存登录信息并跳转（用于已注册用户）
    saveLoginInfoAndGoHome (wssqUser) {
      const params = {
        loginName: this.ruleForm.loginName,
        identificationType: this.ruleForm.identificationType,
        identificationCard: this.ruleForm.identificationCard,
        phone: this.ruleForm.phone,
        isFace: this.oprate == 'apply' ? 1 : null,
        isToWithdraw: this.oprate == 'revokeApply' ? 1 : null,
        verificationCode: '',
        moduleCode: moduleCodeSwitch(),
        id: '',
        loginText: this.ruleForm.loginName
      };
      
      // localStorage.setItem('sessionId', uuid());
      Api.saveLoginInfo(params).then((res) => {
        if (res.data.code === '0') {
          // 保存用户信息
          if (wssqUser) {
            localStorage.setItem('wssqUser', JSON.stringify(wssqUser));
          }
          localStorage.setItem('loginIdentificationCard', this.ruleForm.identificationCard);
          localStorage.setItem('loginName', this.ruleForm.loginName);
          localStorage.setItem('applicantInfo', JSON.stringify(this.ruleForm));
          localStorage.setItem('isLogin', 'true')
          localStorage.setItem('isRegistered', 'true')
          
          // 更新 Vuex 中的登录状态
          this.$store.dispatch('setLoginStatus', {
            userName: this.ruleForm.loginName,
            loginName: this.ruleForm.loginName,
            identificationCard: this.ruleForm.identificationCard
          })
          
          // 连接 WebSocket
          const sessionId = localStorage.getItem('sessionId')
          if (sessionId) {
            websocketManager.connect(
              sessionId,
              (message) => {
                // 消息处理回调
                console.log('收到 WebSocket 消息:', message)
                // 收到消息后执行登出操作
                this.handleLogout()
              },
              (error) => {
                // 错误处理回调
                console.error('WebSocket 错误:', error)
              },
              () => {
                // 连接成功回调
                console.log('WebSocket 连接成功')
              },
              (event) => {
                // 连接关闭回调
                console.log('WebSocket 连接关闭:', event)
              }
            )
          } else {
            console.warn('未找到 sessionId，无法连接 WebSocket')
          }
          
          // 跳转到codeSearch页面
          this.$router.push('/codeSearch');
        } else {
          this.$message({
            message: res.data.msg || '登录失败，请重试',
            type: 'error',
            duration: 4000
          });
        }
      }).catch((err) => {
        console.log('saveLoginInfo error', err);
        this.$message.error('登录失败，请重试');
      });
    },
    // 检查用户是否已注册
    checkUserExist () {
      const { identificationCard, phone } = this.ruleForm;
      
      if (!phone) {
        // 如果没有手机号，直接打开注册弹窗
        this.registerDialogVisible = true;
        return;
      }
      
      Api.checkUserExistByPhoneAndIdentificationCard(identificationCard, phone)
        .then((res) => {
          const state = res.data?.data?.state;
          console.log('checkUserExist res', res);
          
          if (state == 0) {
            // 未注册，打开注册弹窗
            this.$message({
              message: '识别到未注册，请先注册',
              type: 'warning',
              duration: 2000
            });
            setTimeout(() => {
              this.registerDialogVisible = true;
            }, 500);
          } else if (state == 1) {
            // 已注册（身份证一致），调用登录接口并传递用户信息
            const wssqUser = res.data?.wssqUser;
            this.saveLoginInfoAndGoHome(wssqUser);
          } else if (state == 2) {
            // 已注册（身份证不一致），调用接口获取弹窗内容并显示
            this.getRegestStatusDialogContent();
          } else {
            // 其他情况，打开注册弹窗
            this.registerDialogVisible = true;
          }
        })
        .catch((err) => {
          console.log('checkUserExist error', err);
          this.$message.error('检查用户状态失败，请重试');
          // 接口调用失败，打开注册弹窗
          this.registerDialogVisible = true;
        });
    },
    // 获取注册状态弹窗内容
    getRegestStatusDialogContent () {
      Api.getRegestStatusDialogContent().then(res => {
        let tips = ''
        if (res.data.code === '0' && res.data.data) {
          // 处理不同的数据格式
          tips = res.data.data.tips || res.data.data.content || ''
          this.regestStatusPhone = res.data.data.phone || ''
          this.regestStatusTime = res.data.data.time || ''
        }
        
        // 如果获取到内容则使用，否则使用默认内容
        if (!tips) {
          tips = '当前信息已被注册,请确认您的信息填写准确,如您需要申诉或者修改手机号请联系:\n电话: 021-12345678\n时间: 10:00~17:00'
        }
        
        // 将换行符转换为 HTML 换行
        this.regestStatusTips = tips.replace(/\n/g, '<br/>')
        
        // 显示弹窗
        this.showRegestStatusDialog = true
      }).catch(err => {
        console.log('getRegestStatusDialogContent error', err)
        // 接口调用失败，使用默认内容
        this.regestStatusTips = '当前信息已被注册,请确认您的信息填写准确,如您需要申诉或者修改手机号请联系:<br/>电话: 021-12345678<br/>时间: 10:00~17:00'
        this.showRegestStatusDialog = true
      })
    },
    // 关闭注册状态弹窗
    closeRegestStatusDialog () {
      this.showRegestStatusDialog = false
      this.regestStatusTips = ''
      this.regestStatusPhone = ''
      this.regestStatusTime = ''
    },
    // 注册成功回调
    handleRegisterSuccess (userInfo) {
      // 更新表单中的手机号
      if (userInfo.phone) {
        this.ruleForm.phone = userInfo.phone;
      }
      // 注册成功后，重新检查用户状态或直接登录
      this.checkUserExist();
    },
    // 注册弹窗关闭回调
    handleRegisterDialogClose () {
      this.registerDialogVisible = false;
    },
    nextTep () {
      // 人脸识别成功后，先检查用户是否已注册
      this.checkUserExist();
    },
    // 检查是否可以跳过人脸识别
    async checkOperationPhone () {
      try {
        const res = await Api.checkOperationPhone({
          phoneNumber: this.ruleForm.phone
        });
        if (res.data.code === '0') {
          // 返回true表示可以跳过人脸识别
          return res.data.data;
        } else {
          // 接口异常，默认需要人脸识别
          return false;
        }
      } catch (err) {
        // 请求失败，默认需要人脸识别
        console.error('checkOperationPhone error:', err);
        return false;
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // this.nextTep();
          // return 1;
          // 存储申请人信息
          localStorage.setItem('applicantInfo', JSON.stringify(this.ruleForm));
          
          // 检查是否可以跳过人脸识别
          const canSkipFaceId = await this.checkOperationPhone();
          console.log('canSkipFaceId', canSkipFaceId);
          
          if (canSkipFaceId) {
            // 可以跳过人脸识别，直接检查用户是否已注册
            this.nextTep();
          } else {
            // 需要人脸识别，打开人脸识别弹窗
            this.$refs.faceIdTip.open();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main-contentBox{
  padding: 60px 135px 80px;
  height: auto;
  .re-contentBox{
    overflow: auto;
    min-height: 380px;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    display: flex;
    align-items: center;
    justify-content: center;
    .textBox{
      width: 80%;
    }
  }
}
@media screen and (max-width: 1000px) {
  .main-contentBox {
    padding: 60px 80px 80px;
  }
  .tiptext {
    font-size: 12px !important;
  }
  .el-input {
    font-size: 12px !important;
  }
}
@media screen and (max-width: 750px) {
  .main-contentBox {
    padding: 60px 40px 80px;
  }
  .main-contentBox .re-contentBox{
    backdrop-filter:none;
  }
  .re-contentBox {
    padding: 20px 0;
    .el-form-item__content {
      margin-bottom: 0 !important;
      margin-left: 10px !important;
    }
    ::v-deep .el-form-item__label {
      padding: 0px !important;
    }
    .flexEnd {
      display: flex;
      align-items: center;
    }
    .pt10 {
      padding-top: 10px;
    }
    .pt15 {
      padding-top: 15px;
    }
  }
}

.upload-identificationFile{
  .upload-identiFile{
    display: flex;
    background-color: rgb(223,240,253);
    border-radius: 3px;
    height: 40px;
    width: 100%;
    align-items: center;
    .identiFile-btn{
      background-color:#5A9CFF;
      height: 24px;
      width :100%;
      line-height: 23px;
      color: white;
      border-radius: 3px;
      font-size: 12px;
      margin-left: 3px;
    }
    ::v-deep .el-upload-list {
      margin-left: 5px;
      width:70%;
      overflow :hidden;
      white-space: nowrap;
      text-overflow:ellipsis
    }
    ::v-deep .el-upload-list__item:first-child{
      margin-top: 0px;
    }
    ::v-deep .el-upload--text {
      width: 100%;
    }
  }
}
@media screen and (max-width: 500px) {
  .main-contentBox {
    padding: 60px 10px 80px;
  }
  .re-contentBox {
    .text-width {
      width: 100% !important;
      padding-top: 0 !important;
    }
    .el-form-item {
      margin-bottom: 0 !important;
    }
    ::v-deep .el-form-item__error {
      position: static !important;
    }
    .pt10 {
      padding-top: 36px !important;
    }
  }
  .primary-btn, .border-btn {
    width: 100px;
    font-size: 14px;
  }
}
@media screen and (max-width: 300px) {
  .el-form-item {
    width: 100%;
  }
  .re-contentBox .pt10 {
    padding-top: 10px !important;
  }
}

// 注册异常弹窗样式
::v-deep .regest-status-dialog {
  .regest-status-content {
    padding: 20px 0;
    .regest-status-text {
      font-size: 14px;
      color: #606266;
      line-height: 1.8;
      margin-bottom: 15px;
      white-space: pre-wrap;
    }
    .regest-status-contact {
      margin-top: 15px;
      .contact-item {
        font-size: 14px;
        color: #606266;
        line-height: 1.8;
        margin-bottom: 5px;
      }
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>
